import React from "react";

const Blogs = () => {
  return (
    <div className=" p-5 text-white bg-dark">
      <div className="container">
        <img
          className="w-75 mx-auto d-block"
          src="https://i.ibb.co/XVmvsf7/Fornt-End-Developer.png"
          alt=""
        />
      </div>
      <div className="text-area  container w-75 ">
        <h2
          style={{ color: "#60DBFA" }}
          className="text-uppercase fw-bolder my-4"
        >
          {" "}
          Props Type
        </h2>
        <p className="text-left mb-4 fs-4">
          In this post, I will discuss Props type so let’s start 👍. React props
          are used to send data from one component to another component. When a
          component received the wrong type of props data it can fetch some bugs
          and errors in your app. React has an inside mechanism that’s name is
          props types, it’s means props validation.
        </p>
        <h2 style={{ color: "#60DBFA" }}>How do React props work? </h2>
        <p className="fs-4 my-4">
          The answer is simple to react props allowed send data as like
          including string, number, function, array, etc. spouse you have
          multiple components, you can pass data one component to another
          component.
        </p>
      </div>
      <div className="container">
        <img
          className="w-75 mx-auto d-block"
          src="https://i.ibb.co/Gn0SrCC/Fornt-End-Developer.jpg"
          alt=""
        />
      </div>
      <div className="text-area  container w-75 ">
        <h2
          style={{ color: "#60DBFA" }}
          className="text-uppercase fw-bolder my-4"
        >
          {" "}
          JSX :
        </h2>
        <p className="text-left mb-4 fs-4">
          Today we talk about JSX, so without further doing so let’s jump to the
          post. ⚙ Javascript syntax Extention is JSX and it’s referred to as
          javascript XML. JSX is a javascript language and React extension.
        </p>
        <h2 style={{ color: "#60DBFA" }}>Component Lifecycle: </h2>
        <p className="fs-4 my-4">
          In this article, we are discussing component lifecycle React Js. But
          Frist we should understand what is it? Everything flows a cycle in the
          world. One thing we have noticed people are born, grow and die.
          Everything flows Lifecycle, React component do as well. In the same
          way, components are created updating and then die. That’s a component
          life cycle.
          <br />
          <br />
          The component lifecycle has Four parts.
          <br />
          **Initialize
          <br />
          **Updating
          <br />
          **Mounting
          <br />
          **UnMounting
          <br />
          <br />
          So Let’s discuss life cycle methods in different phases.
        </p>
        <h2 style={{ color: "#60DBFA" }}>Initialize : </h2>
        <p className="text-left mb-4 fs-4">
          This phase component going to start the journey by setting the state
          and props. It’s done inside the constructor method.
        </p>

        <h2 style={{ color: "#60DBFA" }}>Mounting : </h2>

        <br />
        <p className="text-left mb-4 fs-4">
          Component mounts on the dom Mounting phase. After the completed phase
          is initialized then this phase comes onto the scene, then the
          component renders the first time. Now we have available phases are :
          The Component Will-Mount and Did-Mount so let’s discuss This topic:
        </p>

        <h2 style={{ color: "#60DBFA" }}>Will-Mount : </h2>
        <p className="text-left mb-4 fs-4">
          Methode called before component mount on the dom otherwise The render
          method is called. Then the component gets Mounted.
        </p>

        <h2 style={{ color: "#60DBFA" }}>Did-Mount :</h2>
        <p className="text-left mb-4 fs-4">
          The component gets the mount on the dom after Methode called. same as
          Component Will Mount it’s called one in the lifecycle. When the render
          method is called before this method execution. However, we can make
          API Easily call updates and the state with API Responses.
        </p>
        <h2 style={{ color: "#60DBFA" }}>Updating :</h2>
        <p className="text-left mb-4 fs-4">
          This is the third stage component passes. When a component is created
          the update phase comes into here. Then the component state is changed
          and re-rendered. Then component data (state props) update response
          user clicking and typing. Then component Result in re-rendering. Now
          we have available phases are: Component will update, should update,
          and did Update.
              </p>
              <br />
         <h4 style={{ color: "#60DBFA", textAlign:'center' }}>
        The next post is Coming soon … Thanks{" "}
      </h4>
      </div>
      
    </div>
  );
};

export default Blogs;
